import React, { CSSProperties } from "react";
import { useTranslation } from "react-i18next";

interface EditProps {
  style?: CSSProperties;
}

const Edit: React.FC<EditProps> = ({ style }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const isRtl = language === "ar";
  return (
    <div
      style={{
        translate: "20px 0px",
        zIndex: 20000,
        backgroundColor: "#FFFFFF",
        border: "1px solid #F2F2F2",
        display: "flex",
        justifyContent: "start",
        alignItems: "center",
        width: "163px",
        height: "38px",
        borderRadius: "8px",
        borderWidth: "1px",
        paddingTop: "4px",
        paddingRight: "30px",
        paddingBottom: "4px",
        paddingLeft: "12px",
        ...style,
      }}
    >
      {t("Automation.Edit")}
    </div>
  );
};

export default Edit;

